import { defineMessages } from 'react-intl';

const translations = {
  breadcrumb: {
    shipments: {
      id: 'pages.shipmentView.breadcrumb.shipments',
      defaultMessage: 'Shipments',
      description: 'label of the shipment breadcrumb',
    },
  },
  title: {
    id: 'pages.createShipment.title',
    defaultMessage: 'Create shipment',
    description: 'title of the create shipment page',
  },
  feedback: {
    shipmentNotCreated: {
      id: 'pages.createShipment.feedback.shipmentNotCreated',
      defaultMessage: 'Shipment could not be created',
      description: 'success message of the create shipment',
    },
  },
};

export default defineMessages(translations);
